import {useCallback, useState} from 'react';
import {v4 as uuid} from 'uuid';
import useUiInteractionEvent from '@contentlab/hooks/analytics/use-interaction-event';
import usePurchaseProcessStartedEvent from '@contentlab/hooks/analytics/use-purchase-process-started-event';
import useNavigation from '@/hooks/use-navigation';

const CONTACT_SALES_URL =
  'https://popularpays.com/lead-survey?form_id=01K0CRCENKDV52751ET826Z4BN';
interface UseContactSalesParams {
  flowName: string;
  interactionLocation: string;
}

function useContactSales({
  flowName,
  interactionLocation,
}: UseContactSalesParams) {
  const {uiInteraction} = useUiInteractionEvent();
  const {purchaseProcessStarted} = usePurchaseProcessStartedEvent(flowName);
  const {navigate} = useNavigation();

  const [presentationId, setPresentationId] = useState<string>(uuid());

  const sendUiInteractionEvent = useCallback(
    (buttonName: string) => {
      uiInteraction({
        item_name: buttonName,
        interaction_location: interactionLocation,
        flow_name: flowName,
        presentation_id: presentationId,
        interaction_id: uuid(),
      });
    },
    [presentationId, interactionLocation, flowName]
  );

  const sendPurchaseProcessStartedEvent = useCallback(
    (product_id: string, process_id?: string) => {
      purchaseProcessStarted({
        presentation_id: presentationId,
        process_id: process_id || uuid(),
        product_id,
        product_name: product_id,
      });
    },
    [presentationId]
  );

  const onContactSalesClick = async () => {
    sendUiInteractionEvent('Contact Sales');
    sendPurchaseProcessStartedEvent('enterprise');
    setPresentationId(uuid());
    navigate(CONTACT_SALES_URL);
  };

  return onContactSalesClick;
}

export default useContactSales;
